export enum UserSpecificContent {
	Public,
	RegisteredUser,
	Member,
	GuestTraveler,
}
